export const LIB_VERSION = '17.0.2'; // autogenerated 
//# sourceMappingURL=version.js.map